export enum CommonPropertyDetailMenuEnum {
    overview = 61,
    propertyLandParcel,
    amenities,
    PropertylandPriceTable,
    PropertyPrices,
    PropertyunitPrices,
    PropertyResidentialRental,
    PropertyRetailRental,
    PropertyOfficeRental,
    PropertyWarehouseRental,
    apartmentPriceAnalysis,
    residentialAnalysis,
    retailAnalysis,
    officeAnalysis,
    warehouseAnalysis,
    landPricesProject,
    VillaPriceAnalysis,
    municipalRegulations,
    ResidentialUnits
}

export const DisableAnchor = [
  'industry_workshop_warehouse', // add more later if needed
];
